export default __webpack_public_path__ + "static/media/zoom-out.a3dcfb5f.svg";